import React from "react";
import UploadImg from "../../component/Upload-img/upload";

const PhotoPage = () => <UploadImg />;

export default PhotoPage;
